import { useEffect } from "react";

export function useDebugTrigger(open: () => void) {
  useEffect(() => {
    window.addEventListener("debug:force-promotion-popup", open);
    return () =>
      window.removeEventListener("debug:force-promotion-popup", open);
  }, [open]);
}
